import React from "react";
import {Button} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import {useTheme} from '@mui/material/styles';
import microsoftButtonIcon from "src/assets/images/azure/microsoftButtonIcon.png";

export const MicrosoftButton = ({
  width,
  onClick,
  title,
  disabled = false,
}: {
  width: string,
  onClick: React.MouseEventHandler,
  title: string,
  disabled?: boolean,
}) => {
  const theme = useTheme()
  return <Button
    variant="contained"
    disabled={disabled}
    sx={{
      width: width,
      maxHeight: "35px",
      color: "white",
      paddingRight: 0,
      backgroundColor: theme.more.submitButtonColor,
      textTransform: "none",
    }}
    startIcon={
      <MicrosoftButtonImage/>
    }
    onClick={onClick}
  >
    {title}
  </Button>;
}

export const MicrosoftButtonImage = () => {
  return <Avatar
    src={microsoftButtonIcon}
    variant="square"
    sx={{
      backgroundColor: "white",
      padding: "2px",
      borderRadius: "3px",
      height: "26px",
      width: "26px",
      marginLeft: "-21px",
    }}
  />;
}
